import * as stylex from '@stylexjs/stylex';
import '../../../styles/tokens.stylex';
import { size } from '../../../styles/tokens.stylex';
export interface FiveStarsProps {
  styles?: stylex.StyleXStyles;
  size?: 'small' | 'medium' | 'large';
}
export function FiveStars({
  size = 'medium',
  styles
}: FiveStarsProps) {
  return <svg viewBox="0 0 148 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...stylex.props([localStyles.svg, sizeMap[size], styles])} role="img">
      <g clipPath="url(#clip0_658_6035)">
        <path d="M23.9104 9.01709C23.709 8.41367 23.1999 7.98081 22.5827 7.88653L16.3179 6.94796L13.4979 0.961709C13.2176 0.368569 12.6442 0 12.0005 0C11.3568 0 10.7834 0.368569 10.5031 0.961709L7.72424 6.92653L1.41828 7.88653C0.801138 7.98081 0.292855 8.41367 0.0905704 9.01709C-0.116 9.6368 0.0365706 10.3088 0.489139 10.7708L5.04997 15.4388L3.97255 22.0182C3.86541 22.6756 4.13112 23.3193 4.66769 23.6973C5.18368 24.0633 5.84711 24.0993 6.3991 23.795L11.9611 20.6887L17.6019 23.795C18.1556 24.0993 18.8173 24.0616 19.3333 23.6973C19.8699 23.3193 20.1365 22.6756 20.0285 22.0182L18.9493 15.4302L23.5119 10.7708C23.9644 10.3088 24.117 9.6368 23.9104 9.01709Z" fill="#EAAD00" />
      </g>
      <g clipPath="url(#clip1_658_6035)">
        <path d="M54.7675 9.01709C54.5661 8.41367 54.057 7.98081 53.4398 7.88653L47.175 6.94796L44.355 0.961709C44.0748 0.368569 43.5013 0 42.8576 0C42.2139 0 41.6405 0.368569 41.3602 0.961709L38.5814 6.92653L32.2754 7.88653C31.6583 7.98081 31.15 8.41367 30.9477 9.01709C30.7411 9.6368 30.8937 10.3088 31.3463 10.7708L35.9071 15.4388L34.8297 22.0182C34.7225 22.6756 34.9882 23.3193 35.5248 23.6973C36.0408 24.0633 36.7042 24.0993 37.2562 23.795L42.8182 20.6887L48.459 23.795C49.0127 24.0993 49.6744 24.0616 50.1904 23.6973C50.727 23.3193 50.9936 22.6756 50.8856 22.0182L49.8064 15.4302L54.369 10.7708C54.8215 10.3088 54.9741 9.6368 54.7675 9.01709Z" fill="#EAAD00" />
      </g>
      <g clipPath="url(#clip2_658_6035)">
        <path d="M85.6247 9.01709C85.4232 8.41367 84.9141 7.98081 84.297 7.88653L78.0321 6.94796L75.2122 0.961709C74.9319 0.368569 74.3584 0 73.7147 0C73.071 0 72.4976 0.368569 72.2173 0.961709L69.4385 6.92653L63.1325 7.88653C62.5154 7.98081 62.0071 8.41367 61.8048 9.01709C61.5982 9.6368 61.7508 10.3088 62.2034 10.7708L66.7642 15.4388L65.6868 22.0182C65.5796 22.6756 65.8454 23.3193 66.3819 23.6973C66.8979 24.0633 67.5613 24.0993 68.1133 23.795L73.6753 20.6887L79.3161 23.795C79.8698 24.0993 80.5316 24.0616 81.0475 23.6973C81.5841 23.3193 81.8507 22.6756 81.7427 22.0182L80.6635 15.4302L85.2261 10.7708C85.6787 10.3088 85.8312 9.6368 85.6247 9.01709Z" fill="#EAAD00" />
      </g>
      <g clipPath="url(#clip3_658_6035)">
        <path d="M116.482 9.01709C116.28 8.41367 115.771 7.98081 115.154 7.88653L108.889 6.94796L106.069 0.961709C105.789 0.368569 105.215 0 104.572 0C103.928 0 103.355 0.368569 103.074 0.961709L100.296 6.92653L93.9896 7.88653C93.3724 7.98081 92.8641 8.41367 92.6619 9.01709C92.4553 9.6368 92.6079 10.3088 93.0604 10.7708L97.6213 15.4388L96.5438 22.0182C96.4367 22.6756 96.7024 23.3193 97.239 23.6973C97.755 24.0633 98.4184 24.0993 98.9704 23.795L104.532 20.6887L110.173 23.795C110.727 24.0993 111.389 24.0616 111.905 23.6973C112.441 23.3193 112.708 22.6756 112.6 22.0182L111.521 15.4302L116.083 10.7708C116.536 10.3088 116.688 9.6368 116.482 9.01709Z" fill="#EAAD00" />
      </g>
      <g clipPath="url(#clip4_658_6035)">
        <path d="M147.339 9.01709C147.137 8.41367 146.628 7.98081 146.011 7.88653L139.746 6.94796L136.926 0.961709C136.646 0.368569 136.073 0 135.429 0C134.785 0 134.212 0.368569 133.931 0.961709L131.153 6.92653L124.847 7.88653C124.23 7.98081 123.721 8.41367 123.519 9.01709C123.312 9.6368 123.465 10.3088 123.918 10.7708L128.478 15.4388L127.401 22.0182C127.294 22.6756 127.56 23.3193 128.096 23.6973C128.612 24.0633 129.276 24.0993 129.828 23.795L135.389 20.6887L141.03 23.795C141.584 24.0993 142.246 24.0616 142.762 23.6973C143.298 23.3193 143.565 22.6756 143.457 22.0182L142.378 15.4302L146.94 10.7708C147.393 10.3088 147.545 9.6368 147.339 9.01709Z" fill="#EAAD00" />
      </g>
      <defs>
        <clipPath id="clip0_658_6035">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_658_6035">
          <rect width="24" height="24" fill="white" transform="translate(30.8571)" />
        </clipPath>
        <clipPath id="clip2_658_6035">
          <rect width="24" height="24" fill="white" transform="translate(61.7142)" />
        </clipPath>
        <clipPath id="clip3_658_6035">
          <rect width="24" height="24" fill="white" transform="translate(92.5713)" />
        </clipPath>
        <clipPath id="clip4_658_6035">
          <rect width="24" height="24" fill="white" transform="translate(123.428)" />
        </clipPath>
      </defs>
    </svg>;
}
const localStyles = {
  svg: {
    kZKoxP: "xxk0z11",
    $$css: true
  }
};
const sizeMap = {
  small: {
    kZKoxP: "xqwie1i",
    $$css: true
  },
  medium: {
    kZKoxP: "xbhzzc1",
    $$css: true
  },
  large: {
    kZKoxP: "x1fju8i8",
    $$css: true
  }
};